import React from 'react';
import { ENUM_ORDER_STATUS } from 'utils/enum';

const OrderStatusTag = ({ status }: { status: ENUM_ORDER_STATUS }) => {
  const styles = {
    [ENUM_ORDER_STATUS.COMPLETED]: '#3FB827',
    [ENUM_ORDER_STATUS.ONGOING]: '#FF9500',
    [ENUM_ORDER_STATUS.CANCELLED]: '#E60A2B',
    [ENUM_ORDER_STATUS.REJECTED]: '#E60A2B',
    [ENUM_ORDER_STATUS.SCHEDULED]: '#0080E5',
    [ENUM_ORDER_STATUS.RECURRING]: '#B26800',
    [ENUM_ORDER_STATUS.PENDING]: '#595959'
  };
  return (
    <div>
      <p className={`text-[${styles[status]}] font-medium text-sm capitalize`}> {status}</p>
    </div>
  );
};

export default OrderStatusTag;
